"use client";
import React, { useState } from "react";
import BreadcrumbComp from "../shared/BreadcrumbComp";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import ReactParser from "html-react-parser";
import { Form, Input, Button, Checkbox, message, notification } from "antd";
import handleCreateApi from "@/actions/handleCreateApi";
const ContactIndex = ({ setting }) => {
  const aboutUs = JSON.parse(setting?.aboutUs || "{}");
  const [api, contextHolder] = notification.useNotification();
  const breadcrumbs = [
    { title: "Trang Chủ", href: "/" },
    { title: "Liên Hệ", href: "/lien-he" },
  ];

  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          const data = {
            ...values,
          };
          const res = await handleCreateApi({ data, url: "/contacts" });
          if (res.error) {
            console.log(res);
            message.error("Có lỗi xảy ra vui lòng thử lại!");
            return;
          }
          form.resetFields();
          api.success({
            title: "Gửi thông tin thành công!",
            description:
              "Chúng tôi sẽ liên hệ với bạn trong thời gian gần nhất. Trân trọng",
          });
        } catch (e) {
          console.log(e);
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <div className="w-full bg-white pb-20">
      {contextHolder}
      <div className="section mx-auto">
        <BreadcrumbComp items={breadcrumbs} />

        <h1 className="text-center text-4xl font-bold my-10">Liên Hệ</h1>
      </div>
      <div className="relative w-full h-[300px] md:h-[400px] bg-neutral-800 flex flex-col justify-center items-center text-white">
        <div className="absolute inset-0 overflow-hidden">
          {/* Note: In a real scenario, we would use a real image. Using a placeholder color for now as per plan, 
                 or if there's a specific class for the banner background in the project, we could use that. 
                 Given the design shows a building, I'll use a dark overlay over a placeholder or just a dark background if no image is available. 
             */}
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Contact Banner"
            className="w-full h-full object-cover opacity-50"
          />
        </div>
      </div>

      {/* Info Cards Section - Floating overlap */}
      <div className="max-w-[1290px] mx-auto px-4 -mt-16 md:-mt-24 relative z-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1: Phone */}
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col items-start hover:-translate-y-2 transition-transform duration-300">
            <div className="bg-[#0C1B56] p-3 rounded-lg mb-4 text-white">
              <FaPhoneAlt size={20} />
            </div>
            <h3 className="text-lg font-bold text-neutral-900 mb-2">
              Điện thoại
            </h3>
            <p className="text-sm text-neutral-600 mb-4">
              Hỗ trợ từ Thứ Hai đến Thứ Sáu, 8:00 - 17:00
            </p>
            <a
              href={`tel:${aboutUs?.soDienThoai || ""}`}
              className="text-[#0C1B56] font-semibold hover:underline"
            >
              {aboutUs?.soDienThoai || ""}
            </a>
          </div>

          {/* Card 2: Email */}
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col items-start hover:-translate-y-2 transition-transform duration-300">
            <div className="bg-[#0C1B56] p-3 rounded-lg mb-4 text-white">
              <FaEnvelope size={20} />
            </div>
            <h3 className="text-lg font-bold text-neutral-900 mb-2">Email</h3>
            <p className="text-sm text-neutral-600 mb-4">
              Hỗ trợ từ Thứ Hai đến Thứ Sáu, 8:00 - 17:00
            </p>
            <a
              href={`mailto:${aboutUs?.email}`}
              className="text-[#0C1B56] font-semibold hover:underline"
            >
              {aboutUs?.email || ""}
            </a>
          </div>

          {/* Card 3: Address */}
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col items-start hover:-translate-y-2 transition-transform duration-300">
            <div className="bg-[#0C1B56] p-3 rounded-lg mb-4 text-white">
              <FaMapMarkerAlt size={20} />
            </div>
            <h3 className="text-lg font-bold text-neutral-900 mb-2">
              Văn phòng chính
            </h3>
            <p className="text-sm text-neutral-600 mb-4">
              Rất hân hạnh được đón tiếp bạn tại văn phòng.
            </p>
            <span className="text-[#0C1B56] font-semibold">
              {aboutUs?.diaChi || ""}
            </span>
          </div>
        </div>
      </div>

      {/* Contact Form & Map Section */}
      <div className="section px-4 !mt-20" id="tu-van">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Column: Form */}
          <div>
            <h2 className="text-3xl font-bold text-neutral-900 mb-4">
              Liên Hệ Chúng Tôi
            </h2>
            <p className="text-neutral-600 mb-8">
              Điền thông tin vào form bên dưới, đội ngũ của chúng tôi sẽ liên hệ
              lại trong thời gian sớm nhất.
            </p>

            <Form form={form} layout="vertical" onFinish={handleOk}>
              <Form.Item
                label="Họ và tên"
                name="fullName"
                rules={[{ required: true, message: "Vui lòng nhập họ và tên" }]}
              >
                <Input placeholder="Họ và tên" size="large" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Vui lòng nhập email" },
                  { type: "email", message: "Email không hợp lệ" },
                ]}
              >
                <Input size="large" placeholder="Nhập email" />
              </Form.Item>

              <Form.Item
                label="Số điện thoại"
                name="phoneNumber"
                rules={[
                  { required: true, message: "Vui lòng nhập số điện thoại!" },
                  {
                    pattern: /(84|0[3|5|7|8|9])+([0-9]{8})\b/,
                    message: "Số điện thoại không hợp lệ!",
                  },
                ]}
              >
                <Input size="large" placeholder="Nhập số điện thoại" />
              </Form.Item>

              <Form.Item
                label="Nội dung"
                name="content"
                rules={[{ required: true, message: "Vui lòng nhập nội dung" }]}
              >
                <Input.TextArea rows={4} placeholder="Nhập nội dung ..." />
              </Form.Item>

              <Form.Item name="privacy" valuePropName="checked">
                <Checkbox>
                  bạn đồng ý với{" "}
                  <a href="#" className="text-[#0C1B56] underline">
                    Chính sách bảo mật
                  </a>{" "}
                  của chúng tôi
                </Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  style={{
                    backgroundColor: "#E5C383",
                    color: "#1a1a1a",
                    fontWeight: "bold",
                    borderRadius: "9999px",
                  }}
                >
                  Gửi thông tin
                </Button>
              </Form.Item>
            </Form>
          </div>

          {/* Right Column: Map */}
          <div className="w-full h-full min-h-[400px] lg:min-h-[600px] rounded-lg overflow-hidden relative isolate">
            {ReactParser(aboutUs?.frameMaps || "")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactIndex;
